"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = require("@osmosys/react");
const react_2 = tslib_1.__importStar(require("react"));
const template_parser_1 = require("@osmosys/template-parser");
const react_use_1 = require("react-use");
const hooks_1 = require("../hooks");
exports.EmailCanvasClearContentButton = () => {
    const { data: { draftEmail }, update, } = hooks_1.useEmailCanvasCanvas('state');
    const blocks = draftEmail.blocks || [];
    const [canClear, toggleCanClear] = react_use_1.useToggle(false);
    const testIfCanClear = react_2.useCallback((blocks) => {
        const newCanClear = template_parser_1.emailTemplateBlocksHave(blocks, 'clearable', true, true);
        if (newCanClear !== canClear) {
            toggleCanClear(newCanClear);
        }
    }, [toggleCanClear, canClear]);
    react_2.useEffect(() => {
        testIfCanClear(blocks);
    }, []);
    react_use_1.useDebounce(() => {
        testIfCanClear(blocks);
    }, 200, [...blocks]);
    return (react_2.default.createElement(react_1.OsmosysFlexFrame.ToolbarButton, { osysName: "EmailCanvasClearContentButton", osysIcon: "erase", onClick: () => {
            if (!canClear) {
                alert('Sorry, but there are no unlocked blocks to clear.');
                return;
            }
            const confirmation = window.confirm('Are you sure?');
            if (confirmation) {
                update({
                    draftEmail: Object.assign(Object.assign({}, draftEmail), { blocks: template_parser_1.clearBlocks(blocks) }),
                });
            }
        }, disabled: !canClear, tooltip: `Clear content ${!(draftEmail && draftEmail.blocks)
            ? '(Save email to enable)'
            : !canClear
                ? '(no unlocked blocks with content to clear)'
                : ''}` }));
};
//# sourceMappingURL=ClearContentButton.js.map